﻿import ComoFuncionaNavbar from './components/ComoFuncionaNavbar';
import ImageBanner from './components/ImageBanner';
import VideoSection from './components/VideoSection';
import EmotionalBanner from './components/EmotionalBanner';
import AcompanamientoSection from './components/AcompanamientoSection';
import ComoFuncionaCTA from './components/ComoFuncionaCTA';
import Footer from '@/pages/home/components/Footer';

export default function ComoFunciona() {
  return (
    <main className="min-h-screen overflow-x-hidden">
      <ComoFuncionaNavbar />
      <ImageBanner />
      <VideoSection />
      <EmotionalBanner />
      <AcompanamientoSection />
      <ComoFuncionaCTA />
      <Footer />
    </main>
  );
}

